export default __webpack_public_path__ + "static/media/blog_hero.440dd832.png";